module.exports = __webpack_public_path__ + "img/videographer-1-600x450.aaa0e2f8.jpg";